module.exports = __webpack_public_path__ + "img/solution-img.b6521e1b.png";